import { Injectable } from '@angular/core';
import { IconResolver, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class IconService {
  private path = '/assets/svg-icons';

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    const resolver: IconResolver = (name) =>
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.path}/${name}.svg`
      );
    this.matIconRegistry.addSvgIconResolver(resolver);
  }
}
